import 'reflect-metadata';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import LocalForage from 'localforage';
import { extendPrototype as extendWithGetItems } from 'localforage-getitems';
import { extendPrototype as extendWithSetItems } from 'localforage-setitems';

import { AppModule } from './app/app.module';
import { ILogger } from './app/common/contracts/logging/logger';
import { environment } from './environments/environment';

import 'hammerjs';

type RequestIdleCallback = (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
declare global {
  interface Window {
    logger: ILogger;
    requestIdleCallback: RequestIdleCallback;
    cancelIdleCallback: (id: number) => void;
  }
}
const requestIdleCallback = (cb, options) => {
  const start = Date.now();
  return setTimeout(() => {
    cb({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
};


window.requestIdleCallback = (window.requestIdleCallback || requestIdleCallback) as RequestIdleCallback;

const cancelIdleCallback = id => {
  clearTimeout(id);
};
window.cancelIdleCallback = window.cancelIdleCallback || cancelIdleCallback;

extendWithSetItems(LocalForage);
extendWithGetItems(LocalForage);

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
bootstrap().catch(err => console.error(err));
